import { render, staticRenderFns } from "./detailType1.vue?vue&type=template&id=76994b65&scoped=true"
import script from "./detailType1.vue?vue&type=script&lang=js"
export * from "./detailType1.vue?vue&type=script&lang=js"
import style0 from "./detailType1.vue?vue&type=style&index=0&id=76994b65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76994b65",
  null
  
)

export default component.exports